import 'babel-polyfill';
import 'url-api-polyfill';
import 'intersection-observer';
//
window.$ = window.jQuery = require('jquery');
require("@fancyapps/fancybox");
import Vue from 'vue';
import { VueHammer } from 'vue2-hammer';
//
import GlobalFooter from './components/global-footer';
import GlobalHeader from './components/global-header';
//
import template from './app-template.html';
//
import { sync } from 'vuex-router-sync';
import router from './router';
import store from './store';
import MomentFilter from './filters/moment';
import {delay, each, get} from 'lodash';
import './global-components';
//
const MENU_ID = 2;

console.log('Starting App');
/*
    This is the root Vue instance.
*/
// Plugins
VueHammer.config.pan = {
    direction: 'horizontal',
};
//
Vue.use(VueHammer);
sync(store, router);
//
// Filters
const GLOBAL_FILTERS = {
    'moment': MomentFilter,
};
//
each(GLOBAL_FILTERS, (value, key) => {
    Vue.filter(key, value);
});
//
//
window.app = new Vue({
    router: router,
    store: store,
    template: template,

    components: {
        'global-footer': GlobalFooter,
        'global-header': GlobalHeader
    },

    data() {
        return {
            loaded: false,
        };
    },

    computed: {
        menu() {
            return this.$store.getters.getMenuByID(MENU_ID);
        },
        page() {
            return this.$store.getters.getPageByPath(
                this.$route.path
            );
        },
        pageSlug() {
            return this.page && this.page.slug ? 'page-' + this.page.slug : 'page-noslug';
        },
    },

    watch: {
        '$route.path': 'routeChanged',
    },

    methods: {
        fetchData() {
            this.loading = true;
            this.$store.dispatch("fetchModuleData", MENU_ID).then(() => {
                this.loading = false;
            });
        },

        routeChanged() {
            // analytics
            if (window.ga) {
                window.ga('set', 'page', this.$route.path);
                window.ga('send', 'pageview');
            }

            window.scrollTo(0, 0);

            let contentAnchor = document.getElementById('content');
            if ( contentAnchor ) {
                contentAnchor.focus();
            }
        },

        getScrollbarWidth() {
            const scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return scrollbarWidth;
        },

        setModalClasses() {
            let showing = this.showingModal;

            // This only works if there isn't already padding on the body
            // (which there shouldn't be).

            if ( showing ) {
                this.scrollBarWidth = this.getScrollbarWidth();
                document.body.style.paddingRight = `${this.scrollbarWidth}px`;
                document.documentElement.classList.add('showing-modal');
            } else {
                document.body.style.paddingRight = '';
                document.documentElement.classList.remove('showing-modal');
            }
        },
    },

    created() {
        this.routeChanged();
        // this.setModalClasses();
        this.fetchData();
    },

    mounted() {
        // Last-resort browser detection because IE11 has a flexbox bug but
        // still passes flexbox feature detection.
        let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if ( isIE11 ) {
            document.documentElement.classList.add('isIE11');
        }
        window.addEventListener('scroll', this.setWindowProperties);
        window.addEventListener('resize', this.setWindowProperties);
    },

}).$mount('#app');